export default __webpack_public_path__ + "static/media/btclogo1.f7bf60aa.png";